<style lang="scss">
  @use "../../../../../assets/css/mixins";
  @use "../../../../../assets/css/design-tokens/colors";

  .explore-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
  }
</style>

<script>
  import NavItem from "../NavItem.svelte";
  import { sidebarIsExpanded } from "../stores/sidebar-store.js";

  const navItem = {
    name: "Explore Features",
    icon: "fa-bolt",
    link: "/explore",
    activeIcon: "fa-bolt",
  };
</script>

<div class="explore-wrapper">
  <NavItem type={$sidebarIsExpanded ? "expanded" : "compressed"} {navItem} />
</div>
